import { Component } from '@angular/core';

@Component({
  selector: 'reporte-Auxiliar-Cuenta',
  styles: [],
  templateUrl: 'reporteAuxiliarCuenta.component.html'
})

export class ReporteAuxiliarCuentaComponent {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/reporteAuxiliarCuenta/reporteAuxiliarCuenta.component.ts